<div class="poll-detail-wrapper" *ngIf="poll">
  <div class="modal-header text-color-primary">
    <h4>{{'WEBCLIENT.CHATROOM.POLL.DETAIL_TITLE' | translate}}</h4>
  </div>
  <div class="modal-body">
    <!-- Flat list, following WhatsApp Web's poll details panel: the question, then every
         option with its count, and each option's voters listed underneath it. -->
    <div class="poll-question">
      {{poll.title}}
      <div class="poll-question-status" *ngIf="poll.is_ended">
        <i class="fa fa-lock"></i> {{'WEBCLIENT.CHATROOM.POLL.ENDED' | translate}}
      </div>
    </div>

    <div class="loading-indicator" *ngIf="isLoading">
      <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
    </div>

    <div class="poll-detail-options" *ngIf="!isLoading">
      <div class="poll-detail-option" *ngFor="let option of poll.options">
        <div class="option-header">
          <span class="option-text">{{option.content}}</span>

          <span class="option-count"
            [ngClass]="{'leading': checkIfLeadingOption(option)}"
            *ngIf="poll.should_display_result === 1">
            <ng-container *ngIf="(option.vote_count || 0) === 1">
              {{'WEBCLIENT.CHATROOM.POLL.VOTES_COUNT.ONE' | translate: {COUNT: option.vote_count || 0} }}
            </ng-container>
            <ng-container *ngIf="(option.vote_count || 0) !== 1">
              {{'WEBCLIENT.CHATROOM.POLL.VOTES_COUNT.MULTIPLE' | translate: {COUNT: option.vote_count || 0} }}
            </ng-container>
            <i class="fa fa-star" *ngIf="checkIfLeadingOption(option)"></i>
          </span>
        </div>

        <div class="option-voters" *ngIf="option.voters && option.voters.length > 0">
          <div class="voter-row" *ngFor="let voter of option.voters">
            <div class="voter-avatar default-contact-avatar" [ngStyle]="{'background-image': getVoterAvatar(voter)}"></div>
            <div class="voter-info">
              <div class="voter-name">
                <ng-container *ngIf="checkIfVoterIsMe(voter)">{{'WEBCLIENT.CHATROOM.POLL.VOTER_YOU' | translate}}</ng-container>
                <ng-container *ngIf="!checkIfVoterIsMe(voter)">{{getVoterDisplayName(voter)}}</ng-container>
              </div>
              <div class="voter-time text-color-secondary">
                <ng-container *ngIf="checkIfVotedToday(voter)">{{'WEBCLIENT.CHATROOM.POLL.VOTED_TODAY' | translate}}</ng-container>
                <ng-container *ngIf="checkIfVotedYesterday(voter)">{{'WEBCLIENT.CHATROOM.POLL.VOTED_YESTERDAY' | translate}}</ng-container>
                <ng-container *ngIf="!checkIfVotedToday(voter) && !checkIfVotedYesterday(voter)">{{getVoterDate(voter)}}</ng-container>
                {{getVoterTime(voter)}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn tn-button-primary" *ngIf="isCreatedByMe && !poll.is_ended && !isReadOnly" (click)="onEndPoll()">
      {{'WEBCLIENT.CHATROOM.POLL.END_BUTTON' | translate}}
    </button>
    <button class="btn btn-default" (click)="close()">
      {{'GENERAL.CANCEL' | translate}}
    </button>
  </div>
</div>
